import React from "react";
import { toast as sonnerToast } from "sonner";

const mapOptions = ({
  autoClose,
  toastId,
  hideProgressBar,
  closeOnClick,
  pauseOnHover,
  draggable,
  progress,
  theme,
  ...rest
} = {}) => {
  const mapped = { ...rest };
  if (toastId !== undefined) mapped.id = toastId;
  if (autoClose !== undefined) {
    mapped.duration = autoClose === false ? Infinity : autoClose;
  }
  return mapped;
};

const sanitize = (message) => {
  if (message === null || message === undefined) return "";
  if (typeof message === "string" || typeof message === "number") return message;
  if (React.isValidElement(message)) return message;
  if (message instanceof Error) {
    return (
      message?.response?.data?.error ||
      message.message ||
      String(message)
    );
  }
  if (typeof message === "object") {
    try {
      return (
        message?.response?.data?.error ||
        message?.message ||
        JSON.stringify(message)
      );
    } catch (e) {
      return String(message);
    }
  }
  return String(message);
};

const wrap = (method) => (message, options) =>
  sonnerToast[method](sanitize(message), mapOptions(options));

export const toast = Object.assign(
  (message, options) => sonnerToast(sanitize(message), mapOptions(options)),
  {
    success: wrap("success"),
    error: wrap("error"),
    info: wrap("info"),
    warning: wrap("warning"),
    warn: wrap("warning"),
    loading: wrap("loading"),
    dismiss: sonnerToast.dismiss,
    promise: sonnerToast.promise,
  }
);
